import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'stc-apps-verification-failed',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './verification-failed.component.html',
  styleUrl: './verification-failed.component.scss',
})
export class VerificationFailedComponent {
  adminEmail = 'm.nasr@qeema.net';
  adminPhone = '+20 123 456 7890';
  copiedField = '';
  copyText(text: string, field: string) {
    navigator.clipboard.writeText(text);

    this.copiedField = field;

    setTimeout(() => {
      this.copiedField = '';
    }, 2000);
  }
}
